import Vue from 'vue';
import { GlobalErrorHandler } from '@piri/error';
import './types';

const globalErrorHandler = new GlobalErrorHandler();

window.onunhandledrejection = ({ reason }) => {
  globalErrorHandler.handle(reason);
};

window.onerror = (message, source, lineno, colno, error) => {
  globalErrorHandler.handle(error);
};

Vue.config.errorHandler = error => {
  globalErrorHandler.handle(error);
};
